import React from "react"
import { Link, useLocation } from "react-router-dom"
import { Navigation } from "./ui/navigation"
import { MobileNav } from "./ui/mobile-nav"
import { ThemeToggle } from "./ui/theme-toggle"
import { LogoWithText } from "./ui/logo-with-text"
import { UserMenu } from "./ui/user-menu"
import { useAuth } from "../hooks/use-auth"
import { safeTrackEvent } from "../lib/analytics-utils"
import { EventCategory } from "../lib/analytics"

export function SiteHeader() {
  const { isAuthenticated } = useAuth()
  const location = useLocation()
  
  const handleLogoClick = () => {
    safeTrackEvent({
      category: EventCategory.Navigation,
      label: "nav_logo_click",
      context: {
        sourcePage: location.pathname,
        destinationPage: "/",
        section: "header"
      }
    });
  };

  return (
    <header className="fixed top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center space-x-2" onClick={handleLogoClick}>
          <LogoWithText />
        </Link>
        <div className="flex items-center space-x-4">
          <Navigation />
          <ThemeToggle />
          {isAuthenticated && <UserMenu />}
          <MobileNav />
        </div>
      </div>
    </header>
  )
}